import DocumentsApi from '../../api/Documents'
import useFetchList from '../../elements/Hooks/useFetchList'
import useSubmit from '../../elements/Hooks/useSubmit'
import React from 'react'
import { isEmpty, pick } from 'lodash'
import { message } from 'antd'

const docsApi = new DocumentsApi()

export default function useActions(
  actionDoc,
  object,
  setObject,
  operationFunc,
  fetch = () => console.log('no fetch after action')
) {
  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions(actionDoc, object.status),
    [object.status, isEmpty(object.status)]
  )
  const [submittingOperation, submitOperation] = useSubmit(operationFunc)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const taskDB = await submitOperation({
      status: operation,
      ...pick(object, ['_key', '_rev', '_id']),
    })
    if (taskDB) {
      setObject(taskDB)
      fetch()
    }
    hide()
  }

  return {
    actions,
    fetchingActions,
    fetchActions,
    submittingOperation,
    submitOperation,
    handleActions,
  }
}
